'use strict';

angular.module('amexReconciliationApp')
    .component('columnSettingsModal', {
        templateUrl: 'scripts/views/components/column-settings-modal.html',
        bindings: {
            closeModalCallback: '&'
        },
        controller: function (AnalyticsService,
                              SiteConfigModel,
                              $translate,
                              toastr,
                              UserPreferencesRepository,
                              UserModel,
                              TransactionFilterModel) {

            var self = this;
            self.columns = {lists: {'List of Columns': [], 'Selected Columns': []}};

            self.$onInit = function () {
                var listOfColumns = SiteConfigModel.getAvailableColumns();

                self.updateSuccess = $translate.instant('columnSettings.SuccessMessage');
                self.updateFailure = $translate.instant('columnSettings.FailureMessage');

                 self.closeModal = self.closeModalCallback;

                // Generate initial model
                self.columns.lists['Selected Columns'] = SiteConfigModel.selectedHeaderColumns(listOfColumns,SiteConfigModel.siteNumber());
                self.columns.lists['List of Columns'] = _.differenceBy(listOfColumns,self.columns.lists['Selected Columns'],'displayValue');
            };

            function getDisplayedColumnList( columnsConfig ) {
                var columnList = [];

                if( columnsConfig !== undefined && columnsConfig !== null ) {
                    for (var i = 0; i < columnsConfig.length; i++) {
                        if (columnsConfig[i].type === 'ACF') {
                            columnList.push( columnsConfig[i].value );
                        } else {
                            columnList.push( columnsConfig[i].displayValue );
                        }
                    }
                }

                return columnList;
            }


            self.saveColumnSettings = function () {
                var columnSettings = {
                    siteNumber: SiteConfigModel.siteNumber(),
                    horizontalColumns: self.columns.lists['Selected Columns']
                };
                UserPreferencesRepository.saveColoumnSettings(columnSettings)
                    .then(function () {
                        toastr.success(self.updateSuccess);
                        TransactionFilterModel.filter('');
                        TransactionFilterModel.fields( getDisplayedColumnList(columnSettings.horizontalColumns) );
                        if (UserModel.currentUserPreferences() != undefined  && UserModel.currentUserPreferences().allSitesColumnPreference != undefined ) {
                            var sitesColumnSettings = _.find(UserModel.currentUserPreferences().allSitesColumnPreference, {'siteNumber': SiteConfigModel.siteNumber()});
                            if (!sitesColumnSettings) {
                                UserModel.currentUserPreferences().allSitesColumnPreference.push(columnSettings);
                            }
                        }
                    }).catch(function () {
                    toastr.error(self.updateFailure);
                }).finally(function () {
                    self.closeModalCallback();
                });
            };
        }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/columnSettingsModal.js
// module id = 441
// module chunks = 0